import React, { useContext, useState } from "react";
import styles from "../../../Styles/Login.module.css";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import Cookies from "js-cookie";
import UserContext from "../../../context/UserContext";
  import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function LoginForm() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const { getUser } = useContext(UserContext);

  const onSubmit = async (data) => {
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await fetch(`${API_BASE_URL}/app/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          email: data.email,
          password: data.password,
        }),
      });

      if (response.status === 200) {
        const _response = await response.json();
        Cookies.set("accessToken", _response.token);
        getUser();
        navigate("/overview");
        toast.success(` Login Successful`, {
          position: "top-left",
        });
      } else {
        throw new Error(response.statusText);
      }
    } catch (error) {
      setError("An error occurred during login. Please try again.");
      console.error("Axios error:", error);
      toast.error(`User Login failed: ${error.message || "Please try again"}`, {
        position: "top-left",
      });
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
      <div className={styles.input_details}>
        <div className={styles.user_id}>
          <label htmlFor="email"></label>
          <input
            type="text"
            placeholder="Enter your email"
            {...register("email", {
              required: "Please type your email",
              pattern: {
                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                message: "Please enter a valid email address",
              },
            })}
            aria-invalid={errors.email ? "true" : "false"}
          />
          {errors.email && (
            <p className={styles.error_msg}>{errors.email.message}**</p>
          )}
        </div>
        <div className={styles.password}>
          <div className={styles.password_input}>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
              {...register("password", {
                required: "Please enter your password",
              })}
              aria-invalid={errors.password ? "true" : "false"}
            />
            <div className={styles.eye_icon} onClick={togglePasswordVisibility}>
              {showPassword ? (
                <AiOutlineEyeInvisible style={{ width: "25px" }} />
              ) : (
                <AiOutlineEye style={{ width: "25px" }} />
              )}
            </div>
          </div>
          <div className={styles.password.text}>
            {errors.password && (
              <p className={styles.error_msg}>{errors.password.message}**</p>
            )}
          </div>
        </div>
      </div>
      <div className={styles.navigation_details}>
        <div className={styles.navigation}>
          <Link className={styles.sign_in} to="/register"></Link>
          <Link className={styles.forgot_pass} to="/reset-password">
            Forgot Password?
          </Link>
        </div>

        <button type="submit" disabled={loading}>
          {loading ? "Loading..." : "Login"}
        </button>
      </div>
      {error && <p className={styles.error_msg}>{error}</p>}
      {success && <p className="success-msg">{success}</p>}
    </form>
  );
}

export default LoginForm;
